// Batched event queue. Flushes on interval, on visibility-hidden, on pagehide.
// Uses sendBeacon when available so the request survives navigation/unload.

const FLUSH_ENDPOINT = "/_wsz/track";
const FLUSH_INTERVAL_MS = 5000;
const MAX_QUEUE_SIZE = 100;

export function createQueue(meta) {
  const events = [];
  const vitals = [];
  let timer = null;
  let started = false;

  function start() {
    if (started) return;
    started = true;
    timer = window.setInterval(flush, FLUSH_INTERVAL_MS);
    // Final flush attempts when the page is going away.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") flush(true);
    });
    window.addEventListener("pagehide", () => flush(true));
  }

  function pushEvent(event) {
    events.push(event);
    if (events.length + vitals.length >= MAX_QUEUE_SIZE) flush();
  }

  function pushVital(vital) {
    vitals.push(vital);
  }

  function flush(final) {
    if (events.length === 0 && vitals.length === 0) return;
    const payload = {
      locale: meta.locale,
      referrer: meta.referrer,
      events: events.splice(0, events.length),
      vitals: vitals.splice(0, vitals.length),
    };
    const body = JSON.stringify(payload);
    try {
      if (final && navigator.sendBeacon) {
        navigator.sendBeacon(FLUSH_ENDPOINT, new Blob([body], { type: "application/json" }));
        return;
      }
      fetch(FLUSH_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
        credentials: "same-origin",
      }).catch(() => {});
    } catch (_) {
      /* swallow — analytics must never break the page */
    }
  }

  return { start, pushEvent, pushVital, flush };
}
